import { IconButton } from "web/components"
import useDropDownMenu from "web/hooks/behaviour/useDropDownMenu"
import { useViewableScheduledExports } from "web/hooks/data"

import ScheduledExportMenu from "./ScheduleExportMenu/ScheduleExportMenu"
import { MENU_TRIGGER_ID } from "./constants"

export default function ScheduledExportButton({ viewId, viewType }) {
  const { DropDownMenu, menuVisible, toggleMenu } = useDropDownMenu({
    triggerElementId: MENU_TRIGGER_ID,
  })

  const scheduledExports = useViewableScheduledExports({ viewId, viewType })

  return (
    <>
      <IconButton
        id={MENU_TRIGGER_ID}
        testId={MENU_TRIGGER_ID}
        name="clock"
        outline={true}
        onClick={toggleMenu}
        active={menuVisible}
        className="hidden sm:flex"
      />
      {menuVisible && (
        <DropDownMenu>
          <ScheduledExportMenu
            scheduledExports={scheduledExports}
            viewId={viewId}
            viewType={viewType}
          />
        </DropDownMenu>
      )}
    </>
  )
}
